















import Vue from 'vue'
import { TheToasts } from '@/components'
import { TheAppBar, TheFooter } from './components'

export default Vue.extend({
    name: 'LayoutApp',

    components: { TheToasts, TheAppBar, TheFooter },
})
